import { t } from '@lingui/macro';
import { Tire } from 'noddi-types';
import { NoddiChip, NoddiDialog, NoddiIconButton } from 'noddi-ui-web';
import { useState } from 'react';
import EuLabel from '../../assets/images/eu-label-explanation.png';
import { TireAttributeWithProgressBar } from './TireAttributeWithProgressBar';

interface TireMetaDataProps {
  tire: Tire;
}

export const TireMetaData = ({ tire }: TireMetaDataProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <div className='flex flex-col gap-2'>
        <div className='flex items-center gap-1'>
          <h5 className='font-bold text-3'>{t`EU tire label`}</h5>
          <NoddiIconButton onClick={() => setIsDialogOpen(true)} variant='ghost' iconSize='small' iconName='Info' />
        </div>
        <div className='-ml-0.5 flex flex-col gap-1'>
          {tire.wetGripClass && (
            <TireAttributeWithProgressBar icon='CloudRain' label={t`Wet grip`} value={tire.wetGripClass} />
          )}
          {tire.rollingResistanceClass && (
            <TireAttributeWithProgressBar
              icon='ElectricCharger'
              label={t`Fuel economy`}
              value={tire.rollingResistanceClass}
            />
          )}
          {tire.soundClass && (
            <TireAttributeWithProgressBar
              icon='Sound'
              label={t`Noise level`}
              value={tire.soundDb}
              attributeType='noise'
            />
          )}
        </div>
        {tire.isStudded && <NoddiChip size='small' label={t`Studded tires`} />}
      </div>
      <NoddiDialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <img src={EuLabel} />
      </NoddiDialog>
    </>
  );
};
